export const locale = {
  links: {
    messages: 'Messages',
    profile: 'Profile & Settings',
    forms: 'Forms',
    covid: 'COVID-19 Screening',
  },
  open_dropdown: 'Open profile menu',
};
